<template>
  <div class="table">
    <table class="table table-sm" ref="table">

      <colgroup>
        <col class="bg-soft-primary" width="10%">
        <col width="15%">
        <col class="bg-soft-primary" width="10%">
        <col width="15%">
        <col class="bg-soft-primary" width="10%">
        <col width="15%">
        <col class="bg-soft-primary" width="10%">
        <col width="15%">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">운행기간</th>
          <td><span>{{elements.stDtti}}<br> ~ {{elements.edDtti}}</span></td>
          <th scope="row">영업거리</th>
          <td><span>{{elements.workDist}}km</span></td>
          <th scope="row">영업시간</th>
          <td><span>{{ changeTimeFormat(elements.workTime)}}</span></td>
          <th scope="row">미터금액</th>
          <td><span>{{insertComma( elements.payFare )}}원</span></td>
        </tr>
        <tr>
          <th scope="row">차량번호</th>
          <td><span>{{elements.carNum}}</span></td>
          <th scope="row">주행거리</th>
          <td><span>{{elements.blankDist}}km</span></td>
          <th scope="row">주행시간</th>
          <td><span>{{ changeTimeFormat(elements.blankTime)}}</span></td>
          <th scope="row"><span v-show="props.isShowHipassFare">통행요금</span></th>
          <td><span v-show="props.isShowHipassFare">{{insertComma( elements.hipassFare )}}원</span></td>
        </tr>
        <tr>
          <th scope="row">사원번호</th>
          <td><span>{{elements.driverId}}</span></td>
          <th scope="row">총 운행거리</th>
          <td><span>{{elements.allDist}}km</span></td>
          <th scope="row">근무시간</th>
          <td><span>{{ changeTimeFormat(elements.allTime)}}</span></td>
          <th scope="row"><span v-show="props.isShowAddFare">추가 요금</span></th>
          <td><span v-show="props.isShowAddFare">{{insertComma( elements.addFare )}}원</span></td>
        </tr>
        <tr v-show="props.isShowTotalFare">
          <th scope="row"></th>
          <td></td>
          <th scope="row"></th>
          <td></td>
          <th scope="row"></th>
          <td></td>
          <th scope="row">합계금액</th>
          <td><span>{{insertComma( elements.allFare )}}원</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import {ref, defineProps, defineExpose} from "vue";
import { insertComma } from "@/components/tacho/common/CommonFunc"

const props = defineProps({
  elements: Object,
  isShowHipassFare: Boolean,
  isShowAddFare: Boolean,
  isShowTotalFare: Boolean,
});

const changeTimeFormat = (hm)=>{
  return `${hm.split(":")[0]}시간 ${hm.split(":")[1]}분`;
}

defineExpose({});

</script>

<style scoped>
* {
  font-size: 0.8rem;
}
th {
  background-color: #e3e3e3 !important;
  border-color: #c9c8c8 !important;
  border-top: 1px solid #c9c8c8;
  border-bottom: 1px solid #c9c8c8;
  font-weight: 500;
  width: 6rem;
}
td {
  border-top: 1px solid #c9c8c8;
  border-bottom: 1px solid #c9c8c8;
  width: 10rem;
}
</style>
